import React, { createContext, useContext, ReactNode } from 'react';
import { useBusiness } from './BusinessContext';

interface TutorialContextType {
  tutorialCompleted: boolean;
}

const TutorialContext = createContext<TutorialContextType | undefined>(undefined);

export function TutorialProvider({ children }: { children: ReactNode }) {
  const { selectedBusiness } = useBusiness();

  // Check if user has completed tutorial
  const tutorialCompleted = selectedBusiness?.tutorial_completed || false;

  return (
    <TutorialContext.Provider value={{ tutorialCompleted }}>
      {children}
    </TutorialContext.Provider>
  );
}

export function useTutorial() {
  const context = useContext(TutorialContext);
  if (context === undefined) {
    throw new Error('useTutorial must be used within a TutorialProvider');
  }
  return context;
}
